import { ITypedReduxAction } from '../../types/redux/actionType';
import { TMapBounds } from '../../types/mapBounds';

export enum EMapBoundsActionType {
  Changed = 'mapBounds/changed',
}

export type TMapBoundsChanged = ITypedReduxAction<EMapBoundsActionType.Changed, TMapBounds>;

export type TMapBoundsActions = TMapBoundsChanged;
